import BookLibraryAdapter from 'teacher-ui-client/adapters/book-library'

export default class BookLibraryCollectionAdapter extends BookLibraryAdapter {}
